import "core-js/modules/es6.regexp.match";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import renderHtmlAst from '../utils/renderHtmlAst';
import Navigation from '../components/Navigation';
import CatchDemoLinks from '../components/CatchDemoLinks';
import Layout from '../components/Layout';
import getPageHeadingsAndHtmlAst from '../utils/getPageHeadingsAndHtmlAst';
import { NAVIGATION, MD_COMPONENTS } from '../config';
import '../assets/stylesheets/prism.scss';
var SIMPLE_LAYOUT = 'simple';

function Template(_ref) {
  var match = _ref.match,
      location = _ref.location,
      _ref$data = _ref.data,
      site = _ref$data.site,
      page = _ref$data.page;

  if (!page && match.path === '/') {
    return React.createElement("div", {
      className: "page-wrapper"
    }, "For site index page create ", React.createElement("code", null, "./docs/index.md"), " file");
  }

  var _getPageHeadingsAndHt = getPageHeadingsAndHtmlAst(page),
      headings = _getPageHeadingsAndHt.headings,
      htmlAst = _getPageHeadingsAndHt.htmlAst;

  var layout = page.frontmatter && page.frontmatter.layout || 'two-column';
  var isSimpleLayout = layout === SIMPLE_LAYOUT;
  var isSinglenavigationItem = headings && headings.length <= 1 || NAVIGATION.length === 0;
  return React.createElement(Layout, null, React.createElement(Navigation, {
    location: location,
    headings: headings,
    navigation: NAVIGATION,
    isSinglenavigationItem: isSinglenavigationItem
  }), React.createElement("div", {
    className: classNames("page-wrapper ".concat(layout, "-layout"), {
      'single-navigation': isSinglenavigationItem
    })
  }, !isSimpleLayout && React.createElement("div", {
    className: "dark-box"
  }), React.createElement(CatchDemoLinks, null, React.createElement("div", {
    className: "content"
  }, renderHtmlAst(htmlAst, {
    components: MD_COMPONENTS
  }))), !isSimpleLayout && React.createElement("div", {
    className: "dark-box"
  })));
}

Template.propTypes = {
  location: PropTypes.any.isRequired,
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.object
    }),
    page: PropTypes.shape({
      headings: PropTypes.array.isRequired,
      htmlAst: PropTypes.object.isRequired
    })
  })
};
export var siteFragment = "3647581080";
export var markdownFragment = "1251514198";
export var query = "853849745";
export default Template;